<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">修改登录密码</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input type='password' v-model="ruleForm.oldPassword"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input type='password' v-model="ruleForm.newPassword"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input type='password' v-model="ruleForm.confirmPassword"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">修改</el-button>
                    <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                ruleForm: {},
                rules: {
                    oldPassword: [
                        {required: true, message: "请输入旧密码", trigger: "blur"}
                    ],
                    newPassword: [
                        {required: true, message: "请输入新密码", trigger: "blur"}
                    ],
                    confirmPassword: [
                        {required: true, message: "请输入新密码", trigger: "blur"}
                    ]
                }
            };
        },
        methods: {
            submitForm(formName) {
                var _this = this;
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        if (_this.ruleForm.newPassword != _this.ruleForm.confirmPassword) {
                            _this.$message({
                                message: "请检查确认密码",
                                type: "error",
                                duration: 1000,
                            });
                        } else {
                            let saveModel
                            let userInfo = _this.$common.user_info()
                            let adminName
                            if (userInfo.admin) {
                                adminName = userInfo.admin.adminName
                            } else if (userInfo.agent) {
                                adminName = userInfo.agent.phone
                            } else if (userInfo.hospital) {
                                adminName = userInfo.hospital.phone
                            }

                            saveModel = Object.assign({}, {
                                oldPassword: _this.ruleForm.oldPassword,
                                newPassword: _this.ruleForm.newPassword,
                                confirmPassword: _this.ruleForm.confirmPassword
                            })
                            _this.$common.my_ajax({
                                url: "/localUser/saveResetPassword",
                                data: saveModel,
                                success: function (response) {
                                    _this.$message({
                                        message: "保存成功",
                                        type: "success",
                                        duration: 1000,
                                        onClose: function () {
                                            _this.$router.push({name: "login"});
                                        }
                                    });
                                }
                            });
                        }
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            savePasswordResetAcount() {
                var _this = this;
                _this.$validator.validateAll().then(result => {
                    if (result) {
                        _this.$common.my_ajax({
                            url: "localUser/saveResetPassword",
                            data: _this.saveModel,
                            success: function (response) {
                                _this.$message({
                                    message: "保存成功",
                                    type: "success",
                                    duration: 1000,
                                    onClose: function () {
                                        _this.$router.push({name: "login"});
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }
    };
</script>
<style scoped>
</style>